<div class="holiday-guests" [ngClass]="{'edit-guests-on-detail-page': isOpenIntoDetailPage}">
  <div class="holiday-guests__title">
    <h4><i class="icon-group-people"></i> Viaggiatori</h4>
  </div>
  <div class="holiday-guests__item">
    <form name="guestsForm">
      <div class="holiday-guests__group">
        <div class="form-group">
          <div class="quotation-guests__selection">
            <label class="col-form-label quotation-guests__label">Viaggiatori</label>
            <div class="spinner-counter">
              <span class="spinner-counter__btn" [ngClass]="{'disabled': occupancy.guests <= 1}" (click)="removeGuest()">
                <i class="icon-minus" ></i>
              </span>
              <input class="spinner-counter__count" name="adultsNumber" [(ngModel)]="occupancy.guests" readonly>
              <span class="spinner-counter__btn" [ngClass]="{'disabled': getTotalGuestsNumber() >= maxGuests}" (click)="addGuest()">
                <i class="icon-plus"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="quotation-guests__content">
            <label class="col-form-label quotation-guests__label">Indica l'età dei viaggiatori alla data di partenza</label>
            <div class="quotation-guests__group">
              <div class="quotation-guests__age age-section">
                <div class="form-row row">
                  <div class="form-group-custom mb-1 col-12 col-lg-6" *ngFor="let age of occupancy.ages; let i = index; trackBy: agesTrackBy">
                    <ng-select [clearable]="false" class="form-control form-ng-select" [(ngModel)]="occupancy.ages[i]" [name]="'guest_age_'+i" placeholder="Seleziona eta'" [items]="agesSelect"></ng-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="btn btn--brand-color-03" (click)="closeModal()">Conferma</button>
    </form>
  </div>
</div>
